<template>
  <div
    id="downloadBarcodeModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ this.$route.meta.breadcrumb }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
                    <div class="form-group mb-3">
                      <label class="label">BARCODE :</label>
                      <input
                        v-model="DlbOldBarcode"
                        type="text"
                        class="form-control"
                        placeholder="BARCODE"
                      />
                    </div>
                  </div>
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
                  >
                    <div class="form-group">
                      <label class="label">รหัสอ้างอิง:</label>
                      <treeselect
                        v-model="DlbRefno"
                        :multiple="true"
                        :load-options="LoadDlbRefnoOptions"
                        :async="true"
                        searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                        placeholder="กรุณาเลือก"
                        :cacheOptions="false"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> ดาวน์โหลด
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      DlbRefno: [],
      DlbRefnoOptions: [],
      DlbOldBarcode: "",
    };
  },
  methods: {
    LoadDlbRefnoOptions({ action, searchQuery, callback }) {
      var self = this;
      self.DlbRefnoOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2RefCode", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.DlbRefnoOptions = [];
              data.forEach((element) => {
                self.DlbRefnoOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.DlbRefnoOptions);
          })
          .catch(function(error) {});
      }
    },
    formSubmit: function(e) {
      e.preventDefault();

      if (this.DlbOldBarcode == "" && this.DlbRefno.length == 0) {
        Swal.fire(
          "",
          "กรุณาระบุข้อมูล BARCODE หรือ รหัสอ้างอิง",
          "warning"
        );
        return false;
      }

      if (
        !$("#downloadBarcodeModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;

      axios({
        method: "post",
        url: "/Api/Barcode/Download",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: null,
          ProductTypeId: [],
          AssetOwnerId: [],
          WarrantyTime: null,
          RefCode: this.DlbRefno,
          OldBarcode: this.DlbOldBarcode,
        },
      })
        .then(function(response) {
          if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
            return false;
          }
          let filename = "";
          let contentType = response.headers["content-type"];
          let disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          let blob = new Blob([response.data], { type: contentType });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          $("#DlbRefno")
            .val("")
            .trigger("change");
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    // set validation rules
    $("#downloadBarcodeModal form").validate({
      rules: { DlbRefno: "required" },
      messages: { DlbRefno: "กรุณาเลือกรหัสอ้างอิง" },
    });

    $("#downloadBarcodeModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        // self.$parent.reloadDataTable(false);
      })
      .modal("show");
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Barcode/DownloadBarcode.vue